import {
    call, all, takeLatest, select,
} from 'redux-saga/effects'
import { AnalyticsActionTypes, getAllEventsActionType, getCallEventsActionType, getTargetedEventsActionType } from "../../model/analytics/actions";
import Api from '../services/ApiManager';
import {Options, execFillRequest } from './effects';
import { getAllEventsAction, getCallEventsAction, getTargetedEventsAction } from '../actions/analyticsActions';

function* getAllEvents(action: AnalyticsActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
        if (botId !== undefined) {
            const options: Options = {
                payload: [botId, action.payload.startDate, action.payload.endDate],
            };
            yield call(execFillRequest,
                Api.analytics.getAll,
                getAllEventsAction.success,
                getAllEventsAction.failure,
                options);
        }
}

function* getCallEvents(action: AnalyticsActionTypes) {
     const botId = yield select(state => state.bot.selectedBot);
        if (botId !== undefined) {
            const options: Options = {
                payload: [botId, action.payload],
            };
            yield call(execFillRequest,
                Api.analytics.getCallEvents,
                getCallEventsAction.success,
                getCallEventsAction.failure,
                options);
        }
}

function* getTargetedEvents(action: AnalyticsActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
        if (botId !== undefined) {
            const options: Options = {
                payload: [botId, action.payload.startDate, action.payload.endDate, action.payload.event],
            };
            yield call(execFillRequest,
                Api.analytics.get,
                getTargetedEventsAction.success,
                getTargetedEventsAction.failure,
                options);
        }
}

export function* startAnalyticsSagas() {
    yield all([
        takeLatest(getAllEventsActionType.request, getAllEvents),
        takeLatest(getCallEventsActionType.request, getCallEvents),
        takeLatest(getTargetedEventsActionType.request, getTargetedEvents),
    ])
}
